module.exports = __webpack_public_path__ + "static/img/pin_red.7a84d51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icons/pin_red.png
// module id = 723
// module chunks = 6